/* eslint no-restricted-globals:0 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { 
  Paper
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: '18px',
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: '20px',
      textAlign: 'left',
      margin: '0 auto',
      [theme.breakpoints.down('lg')]: {
        width: '90%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '70%',
      },
      '& > h1': {
        marginTop: '0px',
        color: '#0e419b',
        textAlign: 'center'
      },
    },
  },
  pdiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  map: {
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      height: '200px',
      margin: '10px',
      order: 2,
      width: '80%',
    },
    [theme.breakpoints.up('md')]: {
      height: '300px',
      margin: '20px',
      width: '80%',
    },
    [theme.breakpoints.up('lg')]: {
      height: '300px',
      margin: '20px',
      width: '50%',
    },
  },
  com: {
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      margin: '10px',
      order: 1,
      width: '100%'
    },
    [theme.breakpoints.up('md')]: {
      height: '300px',
      margin: '20px',
      width: '80%'
    },
    [theme.breakpoints.up('lg')]: {
      margin: '20px',
      width: '50%'
    },
  },
  tablehead: {
    '& > tr': {
      '& > th': {
        borderBottom: '2px solid #c5cae9',
        minWidth: '300px',
        textAlign: 'center'
      }
    }
  },
  tablebody: {
    '& > tr': {
      '& > td': {
        border: 'none',
      },
      '& > th': {
        width: '100px',
        border: 'none',
        textAlignLast: 'justify'
      }
    }
  },
  mail: {
    margin: '0px'
  }
}));

const Price = props => {

  const classes = useStyles();

  return (
    <div className={classes.root}>

    <Paper elevation={3}>
      <h1>サービス提供会社</h1>
      <div class={classes.pdiv}>
        <div className={classes.map}>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.4182833188274!2d136.89011234964957!3d35.171125865291145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60037776c1c207c3%3A0x38d932e488ca67e9!2z5qCq5byP5Lya56S-RFJBR09OIEFHRU5DWQ!5e0!3m2!1sja!2sjp!4v1620261477814!5m2!1sja!2sjp" 
          style={{border:'0px',width: '100%', height: '100%'}} 
          class={classes.frame} allowfullscreen="" loading="lazy"></iframe>
        </div>
        <div className={classes.com}>
          <p style={{fontSize: '24px', textAlign: 'left'}}>株式会社DRAGON AGENCY</p>
          <p style={{fontSize: '14px',textAlign: 'left'}}>私たちは、名古屋を本社として、東京、青森などに拠点を持つ、ソフトウェア開発会社です。詳細はホームページをご覧ください。
            <br />
            <a
                href="https://www.dragonagency.co.jp/"
                target="_blank"
                rel="noopener noreferrer"
            >https://www.dragonagency.co.jp/</a>
          </p>
        </div>
        
      </div>
      
    </Paper>
  </div>
  );
}

Price.propTypes = {
    className: PropTypes.string,
  }

export default Price;